import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { CASH_OUT_REASON_CHOICES, CashOutReasonChoice, exactCashOutReason } from '../../../../../../shared/cash-out-reason';

interface CashOutReasonButton extends CashOutReasonChoice {
  goal?: number;
  img?: string;
}

// The pictures Hope uses for these tiles (ai-rate-finder CashOutReasonComponent.OWN_ICONS): the shared "cash-out" picture
// has "Cash Out" printed on it (both tiles showed it), and the shared Home improvement picture has its label printed on it.
const OWN_ICONS: { [text: string]: string } = {
  'Home improvement': '/assets/images/button-sets/default/new-remodel.png',   // the drawing alone, without its printed label
  'Start or grow a business': '/assets/images/button-sets/default/new-business.svg',
  'Another big purchase': '/assets/images/button-sets/default/new-big-purchase.svg',
};

@Component({
    selector: 'app-cash-out-reason',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['./cash-out-reason.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})

export class CashOutReasonComponent extends ButtonStepComponent implements OnInit {
  title: string = "What is your reason for cashing out?";
  hook = '👍 Your equity, your way.';

  buttonList: CashOutReasonButton[] = CASH_OUT_REASON_CHOICES.map((choice) =>
    OWN_ICONS[choice.text] ? { ...choice, img: OWN_ICONS[choice.text] } : { ...choice });

  ngOnInit() {
    if (this.checkIsHomeEquity()) {
      this.title = "What is your reason for getting home equity?";
    }

    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('cashOutReason', this.control);
    if (!this.form.controls.cashOutReasonDetail) {
      this.form.addControl('cashOutReasonDetail', new UntypedFormControl(''));
    }
  }

  checkIsHomeEquity(): boolean {
    const urlStr = window.location.href;
    try {
      const url = new URL(urlStr);
      const validDomains = [
        'freerateupdate.com',
        'homeequitychoice.com',
        'besthomeequityloan.com'
      ];

      const domainMatch = true; //validDomains.some(domain => url.hostname === domain || url.hostname.endsWith('.' + domain));
      const pathMatch = url.pathname === '/communication/rates-form';

      const params = new URLSearchParams(url.search);
      const isHeloc = params.get('FormType')?.toLowerCase() === 'heloc';
      const isNotPurchase = params.get('lp_button')?.toLowerCase() !== 'purchase';

      return domainMatch && pathMatch && isHeloc && isNotPurchase;
    } catch {
      return false;
    }
  }

  submit(button: CashOutReasonButton) {
    if(button?.goal) {
      this.analyticsService.trackGoal(button.goal);
    }
    this.form.controls.cashOutReasonDetail.setValue(exactCashOutReason('', button && button.text));
    super.submit(button);
  }
}
